import {PropsWithChildren} from "react";
import {Toaster} from "@/components/ui/sonner.tsx";

export function Wrapper({children}: PropsWithChildren) {
    return (
        <div className="h-screen w-screen bg-sky-900/20 flex items-center justify-center p-0 sm:p-6 lg:p-16">
            <div className="flex w-full overflow-hidden bg-white
                h-screen sm:h-[calc(100vh-3rem)] lg:h-[calc(100vh-8rem)]
                rounded-none sm:rounded-3xl lg:rounded-[2rem]
                shadow-none sm:shadow-2xl"
            >
                {children}
            </div>
            <Toaster/>
        </div>
    )
}